<!--
================================================
Un composant qui affiche une synthèse des pointages en graphique par périodes
// @deprecated @since 0.30.1


Description :
 * Les tr sont récupérés depuis l'api rest via getPeriodTimerecords() -> retourne groupedTimerecords
 * Via un watcher sur groupedTimerecords les tr sont triés par sortTimerecords()
 * Les durées sont calculées via la méthode calculateDayDuration

Url d'accès : http://localhost:8080/fr/cronocloud-inc/timeclock

 # AJOUT D'UNE NOUVELLE PÉRIODE :
    - BACKEND :
        * ajouter le nom de la période dans getDailyDurationsForPeriod  (dans le @queryParam et le switch)
    - PWA :
        DANS CE COMPOSANT :
        * ajouter la période dans .periodSelector dans le html
        * ajouter la période dans periodsTotalDuration
        * ajouter une comp prop totalPeriodX

        DANS ChartTrActicityComp :
        * ajouter la periode dans data : periods
        * ajouter la periode dans computed: datas

        DANS LE STORE :
        * ajouter la période dans TimerecordsActivityChartsComp:durations



================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="TimerecordsActivityChartsComp">
        <div class="columns is-desktop">

            <div class="column ">

                <div class="appTitle">
                    <font-awesome-icon :icon="['fas', 'chart-bar']" />
                    {{$t('TableauDeBord')}}
                </div>
                <div class="appBloc blocCharts">

                    <div class="chartArea" >
                        <chart-tr-activity-comp></chart-tr-activity-comp>
                    </div>


                    <div class="columns is-mobile periodTabs" >

                        <a id="periodSelectorLastMonth" class="column periodSelector" v-bind:class="[periodName === 'lastMonth' ? 'active' : '']" v-on:click="definePeriod2Display('lastMonth')">
                            <div class="infos">

                            <span class="periodName">{{ $t('LeMoisDernier')}}</span>
                            <span class="periodeSum" v-if="this.periodsTotalDuration.lastMonth != null">{{totalPeriodLastMonth}}</span>
                            </div>
                        </a>
                        <a id="periodSelectorLastWeek" class="column periodSelector" v-bind:class="[periodName === 'lastWeek' ? 'active' : '']" v-on:click="definePeriod2Display('lastWeek')">
                            <div class="infos">

                            <span class="periodName">{{ $t('laSemaineDernière')}}</span>
                            <span class="periodeSum" v-if="this.periodsTotalDuration.lastWeek != null">{{totalPeriodLastWeek}}</span>
                            </div>
                        </a>

                        <a id="periodSelectorThisWeek" class="column periodSelector" v-bind:class="[periodName === 'thisWeek' ? 'active' : '']" v-on:click="definePeriod2Display('thisWeek')">
                            <div class="infos">

                            <span class="periodName">{{$t('CetteSemaine')}}</span>
                            <span class="periodeSum" v-if="this.periodsTotalDuration.thisWeek != null">{{totalPeriodThisWeek}}</span>
<!--                                <span class="target"> / 35h</span>-->
                            </div>
                        </a>

                        <a id="periodSelectorThisMonth" class="column periodSelector"  v-bind:class="[periodName === 'thisMonth' ? 'active' : '']" v-on:click="definePeriod2Display('thisMonth')">
                            <div class="infos">

                            <span class="periodName">{{$t('CeMoisCi')}}</span>
                            <span class="periodeSum" v-if="this.periodsTotalDuration.thisMonth != null">{{totalPeriodThisMonth}}</span>
                            </div>
                        </a>

                    </div>

                </div>

            </div>


        </div>
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TimeMixin from "../mixins/TimeMixin.js";
    import ChartTrActivityComp from "@/components/ChartTrActivityComp.vue";
    import _ from 'lodash'
    import TrackingMixin from "@/mixins/TrackingMixin";



    export default {

        name: 'TimerecordsActivityChartsComp', //utile dans vue dev tool

        mixins: [GlobalErrorNotification,SentryMixin, InterceptorMixin, TimeMixin,TrackingMixin],
        components: {ChartTrActivityComp},
        data: function () {
            return {

                locale : this.$route.params.locale, // la locale

                periodName: null, // le nom de la période à afficher dans le chart
                timerecordsOfPeriod : null, // les timerecords de pour la période (récupérés depuis api et avant tri)
                trOfPeriodGrouped: null, // les tr regroupés par unités (par exemple par jour, utilisé dans prop computed trOfPeriodGrouped)

                periodsTotalDuration: // contient les durées totales des périodes
                    {thisWeek:null, lastWeek: null, thisMonth: null, lastMonth: null}
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                currentTimeRecord : state => state.currentTimeRecord,
            }),

            //----------------------------------------------

            // other computed props :
            totalPeriodThisWeek: { // la durée total de la période thisWeek formatée
                get: function () {return this.$moment.duration(this.periodsTotalDuration.thisWeek,'milliseconds').format(' h [h] m [m]') },
            },
            totalPeriodLastWeek: { // la durée total de la période lastWeek formatée
                get: function () {return this.$moment.duration(this.periodsTotalDuration.lastWeek,'milliseconds').format(' h [h] m [m]') },
            },
            totalPeriodThisMonth: { // la durée total de la période thisMonth formatée
                get: function () {return this.$moment.duration(this.periodsTotalDuration.thisMonth,'milliseconds').format(' h [h] m [m]') },
            },
            totalPeriodLastMonth: { // la durée total de la période lastMonth formatée
                get: function () {return this.$moment.duration(this.periodsTotalDuration.lastMonth,'milliseconds').format(' h [h] m [m]') },
            },


        },

        watch: {
            // à chaque fois que les data/computed prop changent...
            periodName: function(){
                this.$store.commit('UpdateTimerecordsActivityChartsCompPeriod2Display', this.periodName)
            },

            timerecordsOfPeriod: function () {
                this.sortTimerecords(this.timerecordsOfPeriod);
            },

            // quand les trGouped sont modifiés on relance le calcul des durées
            trOfPeriodGrouped: function () {
                this.calculateDayDuration(this.trOfPeriodGrouped);
            },

            currentTimeRecord: function () {
                // quand le pointage en cours est modifié, on réactualise le chart actuel (s'il est susceptible d'être impacté par le pointage en cours, c'est à dire pour les période qui inclue aujourd'hui : thisWeek,thisMonth)
                if (this.currentTimeRecord == null) { // évite le déclenchement lors de la 1ère définition de currentTimerecord au chargement de la page
                    if (this.periodName == 'thisWeek' || this.periodName == 'thisMonth') {
                        this.getPeriodTimerecords(this.periodName)
                    }
                }
            }

        },

        methods: {

            /**
             * Définit le nom de la période à afficher dans le chart
             **/
            definePeriod2Display(periodName)
            {
                if (periodName != this.periodName) { // on ne modifie pas si la période actuelle est égale à la nouvelle période que l'on veut définir
                    this.periodName = periodName
                    this.getPeriodTimerecords(this.periodName)
                }

                // tracking
                this.$mixpanel.track("[TrActivityChart] period loaded", {"periodName":this.periodName});
                this.ga4GlobalEventTrack('[TrActivityChart] period loaded' , {"periodName":this.periodName})


            },

            /**
             * Calcule la durée total des timerecords
             * @param timerecords Un objet de timerecords groupés par jour ({'2019-07-22T00:00:00+02:00' : [{tr1}, {tr2}]}
             * @returns {array}
             */
            calculateDayDuration: function (timerecords) {

                let self = this;
                let dayDurations = {}; // contient les durées totales par jour

                self.periodsTotalDuration[self.periodName] = null // on réinitialise la durée totale

                // on itère sur l'objet (sur chaque jour qui contient un groupe de tr)
                _.forOwn(timerecords, function (value, key) {

                    // on boucle sur tous les tr du jour...
                    let durationOfDay = null; // durée totale du jour en boucle

                    let i = 1;
                    value.forEach(function (tr) {

                                let duration = self.calculateDuration(self.$moment,tr.timeIn,tr.timeOut);

                                // au premier tour on ajoute l'objet moment duration au total
                                if(i === 1){
                                    durationOfDay = self.$moment.duration(duration);
                                }
                                else { // aux autres tours on additionne
                                    durationOfDay = durationOfDay.add(duration);
                                }
                                i++;

                        dayDurations[key] = {
                            duration4Human: self.formatDuration(durationOfDay,self.$moment,self.locale),
                            duration: durationOfDay._milliseconds // ici récupère les millisecondes dans l'objet duration
                        };


                    });

                });

                // calcul de la durée total de la période /////////////////////
                _.forEach(dayDurations, function (value) {
                    self.periodsTotalDuration[self.periodName] += value.duration
                })

                // passage au store
                let payload = {periodName: self.periodName , data: dayDurations}
                self.$store.commit('UpdateTimerecordsActivityChartsCompDurationsByPeriod', payload)

            },

            /**
             * Récupère les timerecords pour la période
             * @param periodName {string} Le nom de la période (thisWeek, thisMonth, lastWeek etc.)
             */
            getPeriodTimerecords(periodName){
                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeclockMetrics/timerecordsByPeriod`,
                    {
                        params: {period: periodName, type: 'excludeTask'},
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        //IMPORTANT : ici il faut mettre à jour self.timerecordsOfPeriod même si response.data est vide (car il y a des watchers dans ChartTrActivityComp)
                        self.timerecordsOfPeriod = response.data;

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0016'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching timerecords"})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching  timerecords', 'fatal': false})
                            self.$sentry.captureMessage(`Error ${errorCode} > "error fetching timerecords in TimerecordsActivityChartsComp : ${error}`, 'error')
                        }
                    })
            },

            /**
             * Trie les timerecords pour les regrouper par jour
             * @param timerecords Une collection de timerecords
             * @return {object} Un objet contenant des timerecords groupés par jour ( {'2019-07-22T00:00:00+02:00' : [{tr1}, {tr2}]} )
             *
             * inspiré de :https://stackoverflow.com/questions/31890076/array-of-js-dates-how-to-group-by-days
             * Utilise la méthode groupBy de lodash : https://lodash.com/docs/4.17.14#groupBy
             */
            sortTimerecords(timerecords){

                let self = this;

                var groupedTimerecords = _.groupBy(timerecords, function (timerecord) {
                    return self.$moment(timerecord.timeIn).startOf('day').format()
                });

                self.trOfPeriodGrouped = groupedTimerecords

                return groupedTimerecords
            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            this.periodName='thisWeek' // définit la période à afficher par défaut
            this.getPeriodTimerecords(this.periodName); // chargement initial
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    .blocCharts {
        padding: 0;

        .chartArea{
        }
        .periodTabs {
            margin: 0;

            .periodSelector {
                font-size: 0.9rem;
                text-transform: lowercase;
                border-right: solid 1px #eee;font-size: 0.85rem;
                &:last-child{
                    border-right: none;}

                background: #f9f9f9;

                &:hover {
                    background: darken(#f9f9f9, 2%)
                }
                span{
                    text-align: center;
                }

                .infos{
                    text-align: center;
                    .periodName {
                        color: #8c9799;
                        display: block;

                    }

                    .periodeSum {
                        color: $brandThird;

                    }

                    .target {
                        color: $brandPrimary;

                    }
                }

                text-align: left;
                padding-left: 1rem;

                &.active {
                    background: white;
                    &:hover{cursor: default}

                }
            }

        }
    }

</style>
